export const fixPrice = (text: any, region: string) => {
    if (region == 'international') {
        try {
            const inputText = String(text);

            // Split the text into parts before and after the number
            const parts = inputText.split(/(\d*\.?\d+)/);
            if (parts.length < 2) {
                return String(text);
            }

            // Get the number part and parse it
            const numValue = parseFloat(parts[1]);
            if (!isNaN(numValue)) {
                // Preserve text before and after, but format the number part
                const formattedPrice = `$${numValue % 1 === 0 ? numValue : numValue.toFixed(2)}`;
                return parts
                    .map((part, index) => {
                        if (index === 1) return formattedPrice;
                        return part.replace(/\$/g, '').trim(); // Remove any existing $ and trim spaces
                    })
                    .filter(Boolean) // Remove empty parts
                    .join(' ');
            }

            // If we can't parse it as a number, return original text
            return String(text);
        } catch (error) {
            console.log('fixPrice error', error);
            return String(text);
        }
    }
    //if its string return it
    if (typeof text === 'string') {
        return text;
    }
    return '$' + (text);
}